export const allRulesQuery = () => `
    query getAllRulesQuery($page: Int!, $perPage: Int!) {
        rules(page: $page, perPage: $perPage) {
            totalElements
            data {
                id
                name
                trigger
                enabled
                lastExecutionTime
                matches
                conditions {
                    field
                    identifier
                    type
                    value
                }
                actions {
                    type
                    data
                }
                version
            }
      }
    }
`;

export const createRuleQuery = () => `
    mutation createRule($rule: CreateRuleInput!) {
        createRule(rule: $rule)
    }
`;

export const editRuleQuery = () => `
    mutation editRule($id: ID!, $rule: EditRuleInput!) {
         editRule(id: $id, rule: $rule)
    }
`;
